import { CSSProperties, useMemo } from 'react';
import { ROW_HEIGHT, BORDER } from '../../../CONSTANTS';
import { useRowType } from '../../../hooks/useRowType';
import { useGridRowContext } from '../../../../../../_grid/contexts/rowContext';
import { ContractHeader } from './components/ContractHeader';
import { ResourceHeader } from './components/ResourceHeader/ResourceHeader';
import { useGridLayoutContext } from '../../../context/LayoutContext';
import { Icon } from '@fluentui/react';

export const RowHeader = ({ expanded, dropable }: { expanded: boolean; dropable?: boolean }) => {
    const { isResource } = useRowType();
    const { nestingLevel } = useGridRowContext();
    const { rowHeaderSize } = useGridLayoutContext();
    const style = useMemo(() => {
        return {
            //
            ...rowHeaderStyles,
            paddingLeft: 10 * nestingLevel + 10,
            // ...(expanded && isResource && { height: ROW_EXPANDED_HEIGHT }),
            width: `${rowHeaderSize}px`,
        } as CSSProperties;
    }, [nestingLevel, rowHeaderSize]);

    const render = useMemo(() => {
        if (isResource) {
            return <ResourceHeader expanded={expanded} nestingLevel={nestingLevel} />;
        }
        return <ContractHeader expanded={expanded} nestingLevel={nestingLevel} />;
    }, [expanded, nestingLevel, isResource]);
	
    return (
        <div style={style}>
            {render}
            {dropable && (
                <div className="tp-list-capacity-dropzone-overlay tp-grid-top">
                    <span className="drop-text">
                        Drop here <Icon iconName="Download" />
                    </span>
                </div>
            )}
        </div>
    );
};

const rowHeaderStyles: CSSProperties = {
    backgroundColor: 'inherit',
    borderBottom: BORDER,
    borderRight: BORDER,
    boxSizing: 'border-box',
    zIndex: 1,
    height: ROW_HEIGHT,
    position: 'sticky',
    left: 0,
};



